const StringUtils = {
    isNullOrEmpty(s: string | null | undefined) {
        return s == null || s.trim() == '';
    },
    padWithLeadingZeros(num: number, targetLength: number) {
        return String(num).padStart(targetLength, '0');
    }
}

export default StringUtils;